/**
 * @file src/components/molecules/WarningAlert/WarningAlert.tsx
 * @description Customized alert component for displaying warning messages.
 * @module WarningAlert
 */

import React, { FC } from 'react';
import { Alert } from '@/components';
import { AlertProps } from '@/interfaces';

const WarningAlert: FC<AlertProps> = ({
  title = 'Warning',
  icon = 'error',
  description = 'This is just a warning message, but we are so glad you are here.',
  ...props
}) => {
  return (
    <Alert
      intent="warning"
      icon={icon}
      title={title}
      description={description}
      {...props}
    />
  );
};

export default WarningAlert;
